import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import AdminAuthShell, { AuthField, AuthSubmit } from "@/components/AdminAuthShell";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PASSWORD_HINT =
  "Almeno 10 caratteri, con maiuscole, minuscole e almeno un numero.";

export default function AdminPasswordReset() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setError("Le due password non coincidono.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await axios.post(`${API}/admin/password-reset/confirm`, {
        token,
        new_password: password,
      });
      // Un eventuale token vecchio in memoria non è più valido: si riparte pulito.
      localStorage.removeItem("admin_token");
      localStorage.removeItem("admin_email");
      setDone(true);
      setTimeout(() => navigate("/admin/login", { replace: true }), 2500);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Impossibile reimpostare la password.");
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <AdminAuthShell
        testId="admin-reset-page"
        title="Link non valido"
        error="Il link è incompleto o è stato troncato dal programma di posta. Richiedine uno nuovo."
        footer={
          <Link
            to="/admin/password-dimenticata"
            className="text-slate-600 hover:text-slate-900 underline underline-offset-4"
          >
            Richiedi un nuovo link
          </Link>
        }
      />
    );
  }

  return (
    <AdminAuthShell
      testId="admin-reset-page"
      title="Nuova password"
      intro={done ? undefined : "Scegli la password che userai per accedere al pannello."}
      error={error}
      success={done ? "Password reimpostata. Ti stiamo portando alla pagina di accesso..." : ""}
      footer={
        <Link
          to="/admin/login"
          className="text-slate-600 hover:text-slate-900 underline underline-offset-4"
        >
          ← Torna all'accesso
        </Link>
      }
    >
      {!done && (
        <form onSubmit={onSubmit} className="mt-8 space-y-5" data-testid="admin-reset-form">
          <AuthField
            label="Nuova password"
            type="password"
            autoFocus
            required
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            hint={PASSWORD_HINT}
            data-testid="admin-reset-password-input"
          />
          <AuthField
            label="Conferma password"
            type="password"
            required
            autoComplete="new-password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            data-testid="admin-reset-confirm-input"
          />
          <AuthSubmit
            loading={loading}
            loadingLabel="Salvataggio..."
            data-testid="admin-reset-submit"
          >
            Salva la nuova password
          </AuthSubmit>
        </form>
      )}
    </AdminAuthShell>
  );
}
